import axios from '../axios';
import type {
  ApiEnvelope,
  Identifier,
  PaginatedResponse,
  ProviderOpportunityDto,
  ProviderOpportunityParams,
} from './types';

const API_URL = '/v1/provider/manpro/opportunities';

const providerOpportunityService = {
  async getProviderOpportunities(params?: ProviderOpportunityParams) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<ProviderOpportunityDto> | ProviderOpportunityDto[]>>(
      API_URL,
      { params },
    );

    return response.data.content;
  },

  async getProviderOpportunity(id: Identifier) {
    const response = await axios.get<ApiEnvelope<ProviderOpportunityDto>>(
      `${API_URL}/${id}`,
    );

    return response.data.content;
  },

  async getFavoritesIds() {
    const response = await axios.get<ApiEnvelope<string[]>>(
      `${API_URL}/favorites`,
      { params: { ids_only: true } }
    );
    return response.data.content;
  },

  async getFavoriteOpportunities(params?: ProviderOpportunityParams) {
    const response = await axios.get<ApiEnvelope<PaginatedResponse<ProviderOpportunityDto> | ProviderOpportunityDto[]>>(
      `${API_URL}/favorites`,
      { params }
    );
    return response.data.content;
  },

  async addFavorite(id: Identifier) {
    const response = await axios.post<ApiEnvelope<null>>(
      `${API_URL}/${id}/favorite`,
    );
    return response.data.content;
  },

  async removeFavorite(id: Identifier) {
    const response = await axios.delete<ApiEnvelope<null>>(
      `${API_URL}/${id}/favorite`,
    );
    return response.data.content;
  },
};

export default providerOpportunityService;
